var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinancialImpact = function SvgFinancialImpact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 0.8,
    clipPath: "url(#financial-impact_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125 12.25H.875v.875h12.25zM11.813 4.813a.44.44 0 0 0 .437-.438V3.063a.44.44 0 0 0-.289-.412L7.15.901a.44.44 0 0 0-.298 0L2.04 2.651a.44.44 0 0 0-.289.412v1.312a.437.437 0 0 0 .438.438h.437V10.5H1.75v.875h10.5V10.5h-.875V4.813zM2.624 3.369 7 1.776l4.375 1.593v.568h-8.75zm5.25 7.131h-1.75V4.813h1.75zM3.5 4.813h1.75V10.5H3.5zm7 5.687H8.75V4.813h1.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "financial-impact_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgFinancialImpact;